import React, { useState, useEffect,useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { FileUpload } from 'primereact/fileupload';
import { toastify } from '../../../utils/toast';
import { makeRequest2,makeRequest,makeRequest4 } from '../../../utils/makeRequest';
import { powerMeterBaseUrl, getFacilitiesURL } from '../../../utils/urls';
import Layout from '../component/layout';


function PowerMetersDashboard() {
  const navigate = useNavigate();
  const [powerMeters, setPowerMeters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredPowerMeters, setFilteredPowerMeters] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [selectedPowerMeter, setSelectedPowerMeter] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
//  const [formData, setFormData] = useState({ gatewayId: '', gatewayStatus: '' });
//   const [isSubmitting, setIsSubmitting] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(false);
  const clientRef = useRef(null);
  // Configuration states for dropdowns - Now fetched from backend
  const [manufacturers, setManufacturers] = useState([]);
  const [customerBands, setCustomerBands] = useState([]);
  const [facilities, setFacilities] = useState([]);
  const [meterTypes, setMeterTypes] = useState([
    { _id: '2-phase', name: '2 phase' },
    { _id: '3-phase', name: '3 phase' }
  ]);
  const [liveStatusOptions, setLiveStatusOptions] = useState([
    { _id: 'Online', name: 'Online' },
    { _id: 'Offline', name: 'Offline' },
    { _id: 'Faulty', name: 'Faulty' }
  ]);

  // State for file upload dialog
  const [showImportDialog, setShowImportDialog] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);

  // Base URLs for configs - Updated to match your backend routes
  const manufacturerBaseUrl = '/api/core/power_meter_management/controllers/manufacturers';
  const customerBandBaseUrl = '/api/core/power_meter_management/controllers/customer_band';
  const powerMeterUrl = '/power_meters/v1/api/acrel';
  const facilitiesBaseUrl = getFacilitiesURL;

  // Form data state for editing
  const [formData, setFormData] = useState({
    
    
   
    gatewayName:'',
    gatewayStatus: '',
  });

    const handleSubmit2 = async () => {
        const { gatewayId } = formData;
        if (!gatewayId) return alert('Please enter Gateway ID');

        setIsSubmitting(true);
        setCheckingStatus(true);
        setFormData({ ...formData, gatewayStatus: '' , gatewayName:''});

        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/check_acrel_status`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                gatewayId,
                timeout: 30000 // 30 seconds (optional)
            }),
            });

            const result = await response.json();

            if (response.ok && result.success) {
            setFormData(prev => ({
                ...prev,
                gatewayStatus: result.status || 'Unknown', gatewayName: result.gatewayName,
            }));
            } else {
            alert(result.error || 'Failed to get status');
            setFormData(prev => ({ ...prev, gatewayStatus: 'Error' }));
            }
        } catch (error) {
            console.error('Error checking gateway status:', error);
            alert('Failed to connect to backend');
            setFormData(prev => ({ ...prev, gatewayStatus: 'Error' }));
        } finally {
            setIsSubmitting(false);
            setCheckingStatus(false);
        }
    };


  const handleClose = () => {
    if (clientRef.current) clientRef.current.end();
    setFormData({ gatewayId: '', gatewayStatus: '' });
    setIsSubmitting(false);
    setCheckingStatus(false);
    setShowModal2(false);
  };


  const fetchConfigurations = async () => {
    try {
      // Fetch manufacturers from your backend - FIXED
      try {
        const manufacturersRes = await makeRequest2(`${manufacturerBaseUrl}/get_all`, 'GET');
        console.log('Manufacturers response:', manufacturersRes);
        
        if (manufacturersRes && (manufacturersRes.success || manufacturersRes.data)) {
          const manufacturersData = manufacturersRes.data || [];
          
          // Ensure it's an array before setting
          if (Array.isArray(manufacturersData)) {
            setManufacturers(manufacturersData);
          } else {
            console.warn('Manufacturers data is not an array:', manufacturersData);
            setManufacturers([]);
          }
        } else {
          console.log('Failed to fetch manufacturers, using fallback');
          setManufacturers([]);
        }
      } catch (manufacturersError) {
        console.error('Error fetching manufacturers:', manufacturersError);
        setManufacturers([]);
      }

      // Fetch customer bands from your backend - FIXED
      try {
        const customerBandsRes = await makeRequest2(`${customerBandBaseUrl}/get_all`, 'GET');
        console.log('Customer bands response:', customerBandsRes);
        
        if (customerBandsRes && (customerBandsRes.success || customerBandsRes.data)) {
          const customerBandsData = customerBandsRes.data || [];
          
          // Ensure it's an array before setting
          if (Array.isArray(customerBandsData)) {
            setCustomerBands(customerBandsData);
          } else {
            console.warn('Customer bands data is not an array:', customerBandsData);
            setCustomerBands([]);
          }
        } else {
          setCustomerBands([]);
        }
      } catch (customerBandsError) {
        console.error('Error fetching customer bands:', customerBandsError);
        setCustomerBands([]);
      }

      // Fetch facilities - FIXED
      try {
        const facilitiesRes = await makeRequest2(facilitiesBaseUrl, 'GET');
        console.log('Facilities response:', facilitiesRes);
        
        if (facilitiesRes && facilitiesRes.success) {
          let facilitiesData = [];
          
          if (Array.isArray(facilitiesRes.data)) {
            facilitiesData = facilitiesRes.data;
          } else if (facilitiesRes.data && Array.isArray(facilitiesRes.data.facilities)) {
            facilitiesData = facilitiesRes.data.facilities;
          } else if (facilitiesRes.facilities && Array.isArray(facilitiesRes.facilities)) {
            facilitiesData = facilitiesRes.facilities;
          }
          
          setFacilities(facilitiesData);
        } else {
          setFacilities([]);
        }
      } catch (facilitiesError) {
        console.error('Error fetching facilities:', facilitiesError);
        setFacilities([]);
      }
      
    } catch (error) {
      console.error('Error in fetchConfigurations:', error);
      
      // Set fallback empty arrays to prevent map errors
      setManufacturers([]);
      setCustomerBands([]);
      setFacilities([]);
    }
  };

  const fetchPowerMeters = async () => {
    try {
      setLoading(true);
      const response = await makeRequest4(`${powerMeterUrl}/get_all_acrel_gateways`, 'GET');
      console.log('Power meters response:', response);
      
      if (response && (response.success || response.data.data !== undefined)) {
        // Handle different response structures
        let powerMetersData = [];
        
        if (Array.isArray(response.data.data)) {
          powerMetersData = response.data.data;
        } else if (response.data && Array.isArray(response.data.data.powerMeters)) {
          powerMetersData = response.data.powerMeters;
        } else if (response.powerMeters && Array.isArray(response.powerMeters)) {
          powerMetersData = response.powerMeters;
        } else if (response.data.data && response.data.data.length === undefined) {
          // If data is an object but not an array, it might be empty
          powerMetersData = [];
        }
        
        // Ensure it's an array before setting
        if (Array.isArray(powerMetersData)) {
          setPowerMeters(powerMetersData);
          setFilteredPowerMeters(powerMetersData);
        } else {
          console.warn('Power meters data is not an array:', powerMetersData);
          setPowerMeters([]);
          setFilteredPowerMeters([]);
        }
      } else {
        toastify(response?.error || 'Failed to fetch power meters', 'error');
        setPowerMeters([]);
        setFilteredPowerMeters([]);
      }
    } catch (error) {
      console.error('Error fetching power gateways:', error);
      toastify('An error occurred while fetching power gateways', 'error');
      setPowerMeters([]);
      setFilteredPowerMeters([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      await fetchConfigurations();
      await fetchPowerMeters();
    };
    loadData();
  }, []);

  useEffect(() => {
    const filtered = powerMeters.filter(powerMeter =>
      powerMeter.meterSerialNumber?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      powerMeter.manufacturer?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      powerMeter.gatewayId?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredPowerMeters(filtered);
  }, [searchTerm, powerMeters]);

  // Helper function to get facility name
  const getFacilityName = (facilityId) => {
    const facility = facilities.find(f => f._id === facilityId);
    return facility ? facility.name : 'Unknown Facility';
  };

  // Templates for DataTable columns
  const facilityTemplate = (rowData) => getFacilityName(rowData.facilityId);
  const manufacturerTemplate = (rowData) => rowData.manufacturer || 'N/A';
  const typeTemplate = (rowData) => rowData.type || 'N/A';
  const meterReadingTemplate = (rowData) => `${rowData.currentMeterReading || 0} kWh`;
  const lastUpdatedTemplate = (rowData) => {
    if (!rowData.updatedAt) return 'N/A';
    return new Date(rowData.updatedAt).toLocaleDateString();
  };
  const createdAtTemplate = (rowData) => {
    if (!rowData.createdAt) return 'N/A';
    return new Date(rowData.createdAt).toLocaleDateString();
  };

  const statusTemplate = (rowData) => {
    const statusColors = {
      Online: 'success',
      Offline: 'danger',
      maintenance: 'secondary',
      faulty: 'warning'
    };

    return (
      <span className={`badge bg-${statusColors[rowData.gatewayStatus] || 'secondary'}`}>
        {rowData.gatewayStatus}
      </span>
    );
  };

  const statusTemplate2 = (rowData) => {
    const statusColors = {
      active: 'success',
      Inactive: 'danger',
      
    };

    return (
      <span className={`badge bg-${statusColors[rowData.status] || 'secondary'}`}>
        {rowData.status}
      </span>
    );
  };
  const actionsTemplate = (rowData) => (
    <div>
      <Button
        icon="ti ti-edit"
        className="p-button-rounded p-button-info mr-2"
        onClick={() => handleModalOpen(rowData)}
        tooltip="Edit"
      />
      <Button
        icon="ti ti-eye"
        className="p-button-rounded p-button-info mr-2"
        onClick={() => handleModalOpen2(rowData)}
        tooltip="View Realtime"
      />
    </div>
  );

  // Handle file select for import
  const handleFileSelect = (event) => {
    setUploadedFile(event.files[0]);
  };

  // Handle file upload for importing power meters
  const handleFileUpload = async () => {
    if (!uploadedFile) {
      toastify('Please select a file first', 'error');
      return;
    }

    const formDataObj = new FormData();
    formDataObj.append('file', uploadedFile);

    try {
      // You'll need to implement an import endpoint in your backend
      const response = await makeRequest2(`${powerMeterUrl}/import`, 'POST', formDataObj, true);
      if (response.success) {
        toastify('Power meters imported successfully', 'success');
        fetchPowerMeters();
        setShowImportDialog(false);
      } else {
        toastify(response.error || 'Failed to import power meters', 'error');
      }
    } catch (error) {
      toastify('An error occurred while importing power meters', 'error');
    }
  };

  // Open the edit modal and pre-populate form data
  const handleModalOpen = (powerMeter) => {
    if (powerMeter) {
      setSelectedPowerMeter(powerMeter);
      setFormData({
        // meterSerialNumber: powerMeter.meterSerialNumber || '',
        // deviceId: powerMeter.deviceId || '',
        gatewayId: powerMeter.gatewayId || '',
        // meterReading: powerMeter.meterReading || '',
        manufacturer: powerMeter.manufacturer || '',
        // type: powerMeter.type || '',
        gatewayStatus: powerMeter.gatewayStatus || '',
        gatewayName: powerMeter.gatewayName || '',
      });
    }
    setShowModal(true);
  };

   const handleModalOpen2 = (powerMeter) => {
    if (powerMeter) {
      setSelectedPowerMeter(powerMeter);
      setFormData({
        // meterSerialNumber: powerMeter.meterSerialNumber || '',
        // deviceId: powerMeter.deviceId || '',
        gatewayId: powerMeter.gatewayId || '',
        // meterReading: powerMeter.meterReading || '',
        manufacturer: powerMeter.manufacturer || '',
        status: powerMeter.status || '',
        gatewayStatus: powerMeter.gatewayStatus || '',
        createdAt: powerMeter.createdAt || '',
      });
    }
    setShowModal2(true);
  };
  // Handle power meter update submission
  const handleSubmit = async () => {
    console.log('formData', formData)
    // if (!formData.gatewayId.trim()) {
    //   toastify("Gateway ID is required", "error");
    //   return;
    // }
   
    
    console.log("Submitting power meter update with data:", formData);

    setIsSubmitting(true);
    try {
      // Updated to use your new power meter endpoint
      console.log('selectedPowerMeter', selectedPowerMeter)
      const response = await makeRequest4(
        `${powerMeterUrl}/update_acrel_gateway/${selectedPowerMeter._id}`,
        'POST',
        formData
      );

      if (response.success || response.message) {
        toastify('Power meter updated successfully', 'success');
        fetchPowerMeters();
        setShowModal(false);
      } else {
        toastify(response.error || 'Failed to update power meter', 'error');
      }
    } catch (error) {
      console.error('Error updating power meter:', error);
      toastify('An error occurred while updating the power meter', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Import Dialog Component
  const ImportDialog = () => (
    <Dialog
      header="Import Power Meters"
      visible={showImportDialog}
      onHide={() => setShowImportDialog(false)}
      style={{ width: '50vw' }}
    >
      <div className="p-fluid">
        <div className="field mb-4">
          <h5>Upload CSV or Excel File</h5>
          <FileUpload
            mode="basic"
            accept=".csv,.xlsx,.xls"
            maxFileSize={1000000}
            chooseLabel="Choose File"
            className="mb-3"
            onSelect={handleFileSelect}
          />
          <small className="text-muted block">
            Allowed file types: .csv, .xlsx, .xls (Max size: 1MB)
          </small>
        </div>
        <div className="text-end mt-4">
          <Button
            label="Cancel"
            icon="pi pi-times"
            onClick={() => setShowImportDialog(false)}
            className="p-button-text mr-2"
          />
          <Button
            label="Import"
            icon="pi pi-check"
            onClick={handleFileUpload}
            disabled={!uploadedFile}
          />
        </div>
      </div>
    </Dialog>
  );

  return (
    <Layout>
      <ConfirmDialog />
      <div className="page-header">
        <ul className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/core/dashboard">Dashboard</Link>
          </li>
          <li className="breadcrumb-item">Power Gateway Management</li>
          <li className="breadcrumb-item active">Power Gateways</li>
        </ul>
      </div>

      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-header">
              <div className="row">
                <div className="col-3">
                  <div className="form-search">
                    <i className="ti ti-search"></i>
                    <input
                      type="search"
                      className="form-control"
                      placeholder="Search by serial number, manufacturer, or gateway ID"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="row mb-3">
                
              </div>

              <DataTable
                value={filteredPowerMeters}
                loading={loading}
                paginator
                rows={10}
                stripedRows
                emptyMessage="No power meters found."
                tableStyle={{ minWidth: '50rem' }}
              >
                {/* <Column field="meterSerialNumber" header="Serial Number" sortable /> */}
                
                {/* <Column field="deviceId" header="Device ID" sortable /> */}
                <Column field="gatewayName" header="Gateway Name" sortable />
                <Column field="gatewayId" header="Gateway ID" sortable />
                <Column header="Facility" body={facilityTemplate} sortable />
                <Column header="Manufacturer" body={manufacturerTemplate} sortable />
                <Column header="Type" body={typeTemplate} sortable />
                {/* <Column header="Current Reading" body={meterReadingTemplate} sortable /> */}
                <Column field="gatewayStatus" header="Gateway Status" body={statusTemplate} sortable />
                <Column field="status" header="Status" body={statusTemplate2} sortable />
                <Column header="Last Updated" body={lastUpdatedTemplate} sortable />
                <Column header="Created At" body={createdAtTemplate} sortable />
                <Column header="Actions" body={actionsTemplate} />
              </DataTable>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        header="Edit Power Gateway"
        visible={showModal}
        onHide={() => setShowModal(false)}
        style={{ width: '50vw' }}
      >
        <div className="p-fluid">
         

          <div className="field mb-3">
            <label className="form-label">
              Gateway ID<span style={{ color: "red" }}>*</span>
            </label>
            <InputText
              value={formData.gatewayId}
              onChange={(e) => setFormData({ ...formData, gatewayId: e.target.value })}
              className="form-control"
              disabled={isSubmitting}
            />
          </div>

          <div className="field mb-3">
            <label className="form-label">
              Gateway Name<span style={{ color: "red" }}>*</span>
            </label>
            <InputText
              value={formData.gatewayName}
              onChange={(e) => setFormData({ ...formData, gatewayName: e.target.value })}
              className="form-control"
              disabled={isSubmitting}
            />
          </div>
          

          <div className="field mb-3">
            <label className="form-label">
              Status<span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-control"
              value={formData.gatewayStatus || ''}
              onChange={(e) => setFormData({ ...formData, gatewayStatus: e.target.value })}
              disabled={isSubmitting}
            >
              <option value="">Select Status</option>
              {liveStatusOptions.map((s) => (
                <option key={s._id} value={s.name}>
                  {s.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="text-end mt-4">
          <Button
            label={isSubmitting ? "Saving..." : "Save"}
            onClick={handleSubmit}
            disabled={isSubmitting}
            className="p-button-primary"
          />
        </div>
      </Dialog>

      <Dialog
      header="Get Realtime Power Gateway Status"
      visible={showModal2}
      onHide={handleClose}
      style={{ width: '50vw' }}
    >
      <div className="p-fluid">
        <div className="field mb-3">
          
      
        </div>

        <div className="form-control bg-light">
        <div className="field mb-3">
          <label className="form-label">Status</label>
          <div>
            {formData.gatewayStatus 
              ? statusTemplate(formData) 
              : <p className="text-info">⏳ Checking status... Please wait up to 30 seconds.</p>
            }
          </div>
        </div>

        </div>
      </div>

      <div className="text-end mt-4">
        <Button
          label={isSubmitting ? "Checking..." : "Check Status"}
          onClick={handleSubmit2}
          disabled={isSubmitting}
          className="p-button-primary"
        />
      </div>
    </Dialog>
      <ImportDialog />
    </Layout>
  );
}

export default PowerMetersDashboard;